import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import ContentComponent from './contentComponent'
import { motion } from 'framer-motion'

MediaContentLayoutVersionTwo.propTypes = {
  data: PropTypes.object,
}
export default function MediaContentLayoutVersionTwo({ data }) {
  const content_data = {
    top_title: data?.top_title ?? '',
    main_title: data?.main_title ?? '',
    card_media: data?.card_media ?? [],
  }
  return (
    <section className="MediaContentLayoutVersionTwo">
      <div className="main-section-container">
        <div className="title-section">
          <pre>{content_data?.top_title}</pre>
          <h2>{content_data?.main_title}</h2>
        </div>
        <div className="content-section">
          {content_data?.card_media?.map((item, index) => {
            return (
              <motion.div
                style={{
                  position: 'relative',
                }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.3 + 0.3,
                }}
                viewport={{
                  once: true,
                }}
                initial={{
                  opacity: 0,
                  left: '70px',
                }}
                className={`card-item`}
                whileInView={{ opacity: 1, left: '0px' }}
                exit={{ opacity: 0 }}
                key={index}
              >
                <ContentComponent item={item} key={index} />
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
